import React from "react";

function EmailInput( {email, isValid, onChange} ) {

    function handleChange(event) {
        onChange(event.target.value);
    }

    const validationClass = isValid === true ? "is-valid" : isValid === false ? "is-invalid" : ""

    return(
        <>
            <label className="visually-hidden" htmlFor="form-email">E-Mail-Address</label>
            <div className={"input-group has-validation"}>
                <span className={"input-group-text"}>@</span>
                <input
                    className={`form-control ${validationClass}`} type={"email"} name={"form-email"} placeholder={"E-Mail"} required={true} autoComplete={"email"}
                    value={email} onChange={handleChange}
                />
            </div>
        </>
    );
}


export default EmailInput;
